import { OPTIONS } from './time-select.constants';

type GetSecondOptionsSetArgs = {
  maxTimeWindowInHours?: number;
  startTime: string;
};

export function getSecondOptionsSet({ startTime, maxTimeWindowInHours }: GetSecondOptionsSetArgs) {
  const optionsPerHour = 4;
  const defaultMaxTimeWindow = 12;

  const timeWindowForComputation = maxTimeWindowInHours || defaultMaxTimeWindow;

  // let's make sure we don't pass some insane decimal number to this function :arnold-sweat
  // this will always round down to nearest .25 interval (15 minute intervals)
  const maxTimeWindow = Math.floor(timeWindowForComputation * 4) / 4;

  const startIndex = OPTIONS.findIndex((option) => option.value === startTime) + 1;
  const endIndex = startIndex + maxTimeWindow * optionsPerHour;

  const sameDayOptions = OPTIONS.slice(startIndex, endIndex);
  const nextDayOptions = endIndex > OPTIONS.length ? OPTIONS.slice(0, endIndex % OPTIONS.length) : [];

  return [...sameDayOptions, ...nextDayOptions];
}
